module.exports = __webpack_public_path__ + "img/info-vaccine.5aff7cd3.svg";